import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ShieldCheck, KeyRound } from "lucide-react";
import { Panel, inputCls, labelCls, btnPrimary, btnGhost } from "./ui";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PaymentsSection = ({ cfg, onSaved, onChangePassword }) => {
  const [key, setKey] = useState("");
  const [secret, setSecret] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    const body = {};
    if (key.trim()) body.loftpay_api_key = key.trim();
    if (secret.trim()) body.loftpay_webhook_secret = secret.trim();
    if (!Object.keys(body).length) return toast.error("Cole a chave ou o segredo para salvar.");
    setSaving(true);
    try {
      await axios.put(`${API}/config`, body);
      toast.success("Pagamentos atualizados.");
      setKey(""); setSecret("");
      onSaved();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erro ao salvar");
    }
    setSaving(false);
  };

  return (
    <Panel id="config" title="Pagamentos e conta" subtitle="PIX recebido pela LofyPay direto na sua conta." testId="payments-section">
      <div className="grid md:grid-cols-2 gap-5">
        <div className="space-y-3">
          <div className={`flex items-center gap-2 text-sm font-semibold rounded-2xl px-3 py-2.5 ${cfg?.loftpay_api_key_masked ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-800"}`} data-testid="lofypay-status">
            <ShieldCheck size={16} />
            {cfg?.loftpay_api_key_masked ? `PIX ativo · chave ${cfg.loftpay_api_key_masked}` : "PIX em modo de teste — cole sua chave"}
          </div>
          <div>
            <label className={labelCls}>Chave da API LofyPay</label>
            <input type="password" value={key} onChange={(e) => setKey(e.target.value)} placeholder="sk_live_..." className={inputCls} data-testid="lofypay-key-input" />
          </div>
          <div>
            <label className={labelCls}>Segredo do webhook (opcional)</label>
            <input type="password" value={secret} onChange={(e) => setSecret(e.target.value)} placeholder={cfg?.loftpay_webhook_secret_masked || "segredo..."} className={inputCls} data-testid="lofypay-secret-input" />
          </div>
          <button onClick={save} disabled={saving} className={btnPrimary} data-testid="lofypay-save">{saving ? "Salvando..." : "Salvar"}</button>
        </div>
        <div className="rounded-2xl bg-[#FBF8F3] border border-[#EDE6DA] p-5 flex flex-col justify-between gap-4">
          <div>
            <h3 className="font-bold text-slate-900 flex items-center gap-2"><KeyRound size={16} className="text-[#0A66C2]" /> Sua senha</h3>
            <p className="text-sm text-slate-500 mt-1">Troque a senha de acesso ao painel quando quiser.</p>
          </div>
          <button onClick={onChangePassword} className={`${btnGhost} bg-white border border-slate-200 self-start`} data-testid="change-password-button">Trocar senha</button>
        </div>
      </div>
    </Panel>
  );
};
